
import ShapeWide from '@/assets/svg/icons/shape-wide.svg';
import Vue from 'vue';
import { TransformedCmAbstract } from '~/transforms/transformModules';

export default Vue.extend({
  components: {
    ShapeWide,
  },
  props: {
    standalone: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object as () => TransformedCmAbstract['data'],
      required: true,
    },
  },
});
